import type { FotovoltaicoPaginationDTO } from '@/models/dto/fotovoltaico/fotovoltaico-pagination-dto'
import type { PhotovoltaicPlant } from '@/models/types/photovoltaic/photovoltaic-plant'
import type { PhotovoltaicPlantsWithPagination } from '@/models/types/photovoltaic/photovoltaic-plants-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToFotovoltaicoDTO, mapToPhotovoltaicPlant } from './photovoltaic-plant-mapper'

const mapToPhotovoltaicPlants = (dto: FotovoltaicoPaginationDTO): PhotovoltaicPlantsWithPagination => {
    return {
        plants: dto.fotovoltaico?.map((fotovoltaico) => mapToPhotovoltaicPlant(fotovoltaico) as PhotovoltaicPlant),
        pagination: mapToPagination(dto.paginationData),
    }
}

const mapToFotovoltaicoPaginationDTO = (
    photovoltaicPlants: PhotovoltaicPlantsWithPagination,
): FotovoltaicoPaginationDTO => {
    return {
        fotovoltaico: photovoltaicPlants.plants?.map((photovoltaic) => mapToFotovoltaicoDTO(photovoltaic)) ?? null,
        paginationData: mapToPaginationDTO(photovoltaicPlants.pagination),
    }
}

export { mapToFotovoltaicoPaginationDTO, mapToPhotovoltaicPlants }
